import React from "react";


class TagsInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      errorTag: ""
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      tags: nextProps.tags || []
    })
  }

  removeTags = indexToRemove => {
    let { tags } = this.state
    tags = [...tags.filter((_, index) => index !== indexToRemove)]
    this.setState({
      tags
    }, () => this.props.selectedTags(tags))
  }

  addTags = event => {
    const { value } = event.target
    const tagList = this.state.tags
    if(!value.trim().replace(/\s+/g, " ")){
      return
    }
    if(tagList && tagList.length){
      const tag = tagList.map(t => t.trim().replace(/\s+/g, " ").toLowerCase())
      if(tag.indexOf(value.trim().replace(/\s+/g, " ").toLowerCase()) > -1){
        return this.setState({
           errorTag: "Please enter unique tag!"
        })
      } else {
        this.setState({
          errorTag: ""
        })
      }
    }
    if (value !== "") {
      let { tags } = this.props
      tags = [...tags, value]
      this.setState({
        tags
      }, () => this.props.selectedTags(tags))
      // props.selectedTags([...tags, event.target.value]);
      event.target.value = "";
    }
  };

  render(){
    const { errorTag } = this.state
    const { tags } = this.props
    return(
      <div className="tags-input">
        <ul id="tags">
          {tags.map((tag, index) => (
            <li key={index} className="tag">
              <span className='tag-title'>{tag}</span>
              <span className='tag-close-icon'
                    onClick={() => this.removeTags(index)}
              >
                x
              </span>
            </li>
          ))}
        </ul>
        <input
          style={tags.length ? {marginBottom: 5} : {marginBottom: 5, marginTop: 5}}
          className="form-control"
          type="text"
          onKeyUp={event => (event.key === "Enter" || event.key === " ") ? this.addTags(event) : null}
          placeholder="Press enter or press Space bar to add tags"
        />
        <span className="text-danger">{errorTag || ""}</span>
      </div>
    )
  }
}

export default TagsInput;